import { FC } from 'react';
import { Box, TextFieldProps, BoxProps, TypographyProps, Typography } from '@mui/material';
import { StyledTextInput, StyledInputLabel } from './AMBGTextField.style';
import { colors } from 'assets/styles/AMBGTheme';

interface IProps {
	label: string;
	subLabel?: string;
	boxProps?: BoxProps;
	labelProps?: TypographyProps;
	inputPropsTestId?: string;
}

const AMBGTextField: FC<IProps & TextFieldProps> = (props) => {
	const { label, subLabel, boxProps, labelProps, inputPropsTestId, ...rest } = props;

	return (
		<Box width='100%' {...boxProps}>
			<StyledInputLabel {...labelProps}>
				{label}{' '}
				<Typography component='span' sx={{ color: colors.secondary.light, fontSize: '11px' }}>
					{subLabel}
				</Typography>
			</StyledInputLabel>
			<StyledTextInput
				size='small'
				variant='outlined'
				fullWidth
				inputProps={{ 'data-testid': inputPropsTestId }}
				{...rest}
			/>
		</Box>
	);
};

export default AMBGTextField;
